import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserAdministration from './pages/user-administration';
import CalendarScheduling from './pages/calendar-scheduling';
import BillingInvoice from './pages/billing-invoice';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import DocumentManagement from './pages/document-management';
import CaseManagement from './pages/case-management';
import ClientManagement from './pages/client-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Login />} />
        <Route path="/user-administration" element={<UserAdministration />} />
        <Route path="/calendar-scheduling" element={<CalendarScheduling />} />
        <Route path="/billing-invoice" element={<BillingInvoice />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/document-management" element={<DocumentManagement />} />
        <Route path="/case-management" element={<CaseManagement />} />
        <Route path="/client-management" element={<ClientManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
